import delay from './delay';
import Assert from './assert';

export default function delayForEnv() {
  Assert.isPresent(import.meta.env.VITE_APP_ENV, 'VITE_APP_ENV');
  return import.meta.env.VITE_APP_ENV === 'production' ? delay(200) : delay(1000);
}
